import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import TrackerOverview from "@/pages/internal/TrackerOverview";
import { DriveSettings } from "@/components/portal/DriveSettings";

export default function CampaignsTracker() {
  const [drive, setDrive] = useState(null);

  const loadDrive = useCallback(async () => {
    try {
      const { data } = await api.get("/drive/status");
      setDrive(data);
    } catch {
      setDrive(null);
    }
  }, []);

  useEffect(() => {
    loadDrive();
  }, [loadDrive]);

  return (
    <div data-testid="campaigns-tracker-page">
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl">Campaigns Tracker</h1>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed body-text md:text-base">
          Every campaign as a card. Open one to review its performance, submissions and invoices on
          a single page — the counts on a card link straight to the part that needs attention.
        </p>
      </div>

      <DriveSettings status={drive} onChanged={loadDrive} />

      <TrackerOverview />
    </div>
  );
}
